import React from 'react';
import { Link } from 'react-router-dom';

import SectionIcon from '@/components/common/SectionIcon/SectionIcon';

import Heading from '../Heading/Heading';
import { TitleType } from './types';
import styles from './section-card.module.scss';


interface ITitleProps {
  title: TitleType;
}

export default function Title({ title }: ITitleProps) {
  return (
    <div className={styles['ag-section-details__title']}>
      <SectionIcon />
      {title.titleLink ? (
        <Link
          to={title.titleLink}
          className={styles['ag-section-details__title-link']}
        >
          {title.titleText}
        </Link>
      ) : (
        <Heading
          level={2}
          className={styles['ag-section-details__title-main']}
        >
          {title.titleText}
        </Heading>
      )}

      {title.additionalText && (
        <span className={styles['ag-section-details__title-additional']}>{title.additionalText}</span>
      )}
    </div>
  );
}
